import React from "react";
import Image from "next/image";
import c1 from "assets/img/landing/c1.png";
import c2 from "assets/img/landing/c2.png";
import c3 from "assets/img/landing/c3.png";
import c4 from "assets/img/landing/c4.png";
import c5 from "assets/img/landing/c5.png";
import c6 from "assets/img/landing/c6.png";
import c7 from "assets/img/landing/c7.png";
import c8 from "assets/img/landing/egCompany.png";
import c9 from "assets/img/landing/c9.png";
import c10 from "assets/img/landing/c10.png";
import c11 from "assets/img/landing/c11.svg";
import c12 from "assets/img/landing/c12.svg";

import ContactUs from "./contactUs/index";
import { useTranslation } from "react-i18next";
function index() {
  const { t } = useTranslation();

  const images = [
    c1,
    c2,
    c3,
    c4,
    c5,
    c6,
    c7,
    c8,
    c9,
    c10,
    c11,
    c12,
    c1,
    c2,
    c3,
    c4,
    c5,
    c6,
    c7,
    c8,
    c9,
    c10,
    c11,
    c12,
  ];

  return (
    <>
      <div className="container m-auto py-15">
        <div className="mx-5 md:mx-0">
          <div className="text-3xl font-bold text-center">
            {t("OUR CLIENTS")}
          </div>
          <div className="mt-15 text-[#717171] max-w-[1323px] text-center m-auto text-[20px]">
            {t(
              "PLATFARM currently offers services to clients in Egypt, UAE and KSA. We offer our services to medium-large scale agribusiness, commercial growers, and governmental projects growing crops under Center Pivot and Drip Irrigation systems, we also serve Tree Farms like date palm and citrus under drip irrigation system."
            )}
          </div>
        </div>
      </div>

      <div className="marquee">
        <div className="marquee-content">
          {images.map((image, i) => (
            <div key={i + Math.random()} className="marquee-item">
              <Image src={image} alt="img" />
            </div>
          ))}
        </div>
      </div>

      <div className="container m-auto">
        <div className="m-auto mx-5 md:mx-0">
          <ContactUs />
        </div>
      </div>
    </>
  );
}

export default index;
